// extracted by mini-css-extract-plugin
export var atLogo = "styles-module__atLogo___ZAlgJ";
export var browserImageContainer = "styles-module__browserImageContainer___nJc8S";
export var browserLogo = "styles-module__browserLogo___WZ2p0";
export var button = "styles-module__button___ShZWd";
export var close = "styles-module__close___a0rcY";
export var container = "styles-module__container___UVsry";
export var contentContainer = "styles-module__contentContainer___GPz7P";
export var divider = "styles-module__divider___I7Kri";
export var nameAndRatingContainer = "styles-module__nameAndRatingContainer___CTTXp";
export var noPointer = "styles-module__noPointer___opE_3";
export var optionContainer = "styles-module__optionContainer___Ncw2x";
export var optionInfo = "styles-module__optionInfo___hysIF";
export var ratingContainer = "styles-module__ratingContainer___RlidX";
export var ratingNumber = "styles-module__ratingNumber___QUV_C";
export var slideIn = "styles-module__slideIn___cxo8w";
export var variantContainer = "styles-module__variantContainer___mxFHj";